import { z } from 'zod'

export const cityOpeningSchema = z.object({
  year: z.number().int().min(1900).max(2100),
  count: z.number().int().min(0),
})

export const importCitySchema = z.object({
  name: z.string().trim().min(1),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  postalCode: z.string().nullable(),
  departmentCode: z.string().nullable(),
  departmentName: z.string().nullable(),
  openings: z.array(cityOpeningSchema),
})

export const importPreProjectsSchema = z.object({
  cities: z.array(importCitySchema).min(1),
})

export const updatePreProjectCountSchema = z.object({
  openingsCount: z.number().int().min(0),
})

export const updateCitySchema = z.object({
  latitude: z.number().optional(),
  longitude: z.number().optional(),
  postalCode: z.string().optional(),
  departmentCode: z.string().optional(),
  departmentName: z.string().optional(),
})

export type CityOpeningInput = z.infer<typeof cityOpeningSchema>
export type ImportCityInput = z.infer<typeof importCitySchema>
export type ImportPreProjectsInput = z.infer<typeof importPreProjectsSchema>
export type UpdatePreProjectCountInput = z.infer<typeof updatePreProjectCountSchema>
export type UpdateCityInput = z.infer<typeof updateCitySchema>
